import { ComponentProps, forwardRef, useState } from "react";

/**
 * @component
 * Компонент поля
 * @property Доступны все пропсы для типа Input
 * @property clearable - Добавляет кнопку для очистки поля
 * @property hasError - Добавляет красную границу при ошибке
 * @description
 * Текстовое поле с возможностью очистки
 */

const CustomInput = forwardRef<HTMLInputElement, ComponentProps<"input"> & { clearable?: boolean; hasError?: boolean }>(
  ({ readOnly, className, clearable, value, onChange, hasError, ...props }, ref) => {
    const [internalValue, setInternalValue] = useState(value || '');
    const isControlled = value !== undefined;
    const currentValue = isControlled ? value : internalValue;
        const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      if (!isControlled) {        
        setInternalValue(e.target.value);
      }
      onChange?.(e);
    };

    const handleClear = () => {
      if (!isControlled) {
        setInternalValue('');
      }
      // Создаем искусственное событие изменения
      const event = {
        target: { value: '', name: props.name },
        currentTarget: { value: '', name: props.name },
      } as React.ChangeEvent<HTMLInputElement>;
      onChange?.(event);
    };

    const borderColor = hasError ? 'border-[#b21913] border-[2px]' : 'border-[#B1B1B1]';

    const textStyle = !hasError ? 'text-[#313131]' : 'text-[#b21913]';


    return (
      <div className="relative">
        <input
          {...props}
          ref={ref}
          value={value}
          onChange={handleChange}
          className={`w-full placeholder:text-[#31313199] placeholder:font-medium  ${textStyle}  bg-white border-1 ${borderColor} rounded-[15px] px-[1.063rem] py-[0.938rem] outline-none disabled:bg-gray-300 ${
            readOnly && "cursor-default"
          } ${className}`}
        />
        {clearable && currentValue && !readOnly && !props.disabled && (
          <button
            type="button"
            onClick={handleClear}
            className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
            aria-label="Очистить поле"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        )}
      </div>
    );
  }
);

CustomInput.displayName = "CustomInput";

export default CustomInput;